// Generated by CoffeeScript 2.7.0
var strikethrough, text_bg_color, text_color, underline;

import {
  marks
} from 'prosemirror-schema-basic';

strikethrough = {
  parseDOM: [
    {
      tag: 'strike'
    },
    {
      style: 'text-decoration:line-through'
    },
    {
      style: 'text-decoration-line:line-through'
    }
  ],
  toDOM: function() {
    return [
      'span',
      {
        style: 'text-decoration:line-through'
      }
    ];
  }
};

underline = {
  parseDOM: [
    {
      tag: 'u'
    },
    {
      style: 'text-decoration:underline'
    }
  ],
  toDOM: function() {
    return [
      'span',
      {
        style: 'text-decoration:underline'
      }
    ];
  }
};

text_color = {
  attrs: {
    color: {}
  },
  parseDOM: [
    {
      tag: 'span',
      getAttrs: function(dom) {
        if (dom.style.color) {
          return {
            color: dom.style.color
          };
        } else {
          return false;
        }
      }
    }
  ],
  toDOM: function(mark) {
    return [
      'span',
      {
        style: `color: ${mark.attrs.color}`
      }
    ];
  }
};

text_bg_color = {
  attrs: {
    color: {}
  },
  parseDOM: [
    {
      tag: 'span',
      getAttrs: function(dom) {
        if (dom.style.backgroundColor) {
          return {
            color: dom.style.backgroundColor
          };
        } else {
          return false;
        }
      }
    }
  ],
  toDOM: function(mark) {
    return [
      'span',
      {
        style: `background-color: ${mark.attrs.color}`
      }
    ];
  }
};

export default {...marks, underline, strikethrough, text_color, text_bg_color};
